<template>

  <div class="listino-cliente">

    <b-loading :is-full-page="false" v-model="loading"></b-loading>

    <template v-if="!loading">

      <h3 class="title is-3">{{trans.get('listino.title')}}</h3>

      <div class="table" v-if="listino && listino.length > 0">

        <b-table
          :data="listino"
          :bordered="true"
          :striped="true"
          :hoverable="true"
          :mobile-cards="false">

            <b-table-column field="codArt" label="Codice Articolo" v-slot="props" :searchable="true">
              {{props.row.codArt}}
            </b-table-column>

            <b-table-column field="codArt" label="Prezzo" v-slot="props">

              <span v-if="!props.row.trovato || props.row.scaglioni[0].prezzoNetto === 0"><strong>Nessun prezzo trovato...</strong></span>

              <template v-else>

                <div class="scaglione" v-for="(scaglione, index) in props.row.scaglioni" :key="index">

                  A partire da a: {{scaglione.qta}} - {{scaglione.prezzoNetto.toLocaleString('it-IT', {minimumFractionDigits: 3})}}&euro;

                </div>

              </template>

            </b-table-column>

        </b-table>

      </div>

    <p class="empty" v-else>Nessun articolo trovato...</p>

    </template>

  </div>

</template>

<script>
export default{

  props: ['codclifor'],

  data(){

    return {
      loading: false,
      listino: null,
      cliente: null
    }

  },

  methods: {

    loadListino(){

      var vue = this;
      vue.loading = true;

      axios({
        method: "get",
        url: window.location.origin +  '/data/get-listino-cliente',
        params: {
          'codclifor': vue.codclifor
        }
      })
      .then(res => {

        vue.listino = res.data.listino

      })
      .catch(err => {

        vue.listino = [];

      })
      .finally(() =>{

        vue.loading = false;

      })

    }

  },

  mounted(){

    this.loadListino();

  }



}
</script>

<style lang="scss" scoped>
.listino-cliente{
  padding: 2em;
  position: relative;
  min-height: 50px;
}
</style>
